import * as React from "react";
import Box from "@mui/material/Box";
import { Button, Typography } from "@mui/material";

export default function LandingPage() {

  function handleScroll() {
    const element = document.getElementById('lets_connect');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  return (
    <Box
      sx={{
        width: "100%",
        height: "68vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        margin: "auto",
        // background: "linear-gradient(180deg, rgba(244, 249, 255, 0) 0%, #F4F9FF 100%)",
        background: "linear-gradient(0deg, rgba(244, 249, 255, 0) 0%, #F4F9FF 100%)",
      }}
    >
      <Box
        sx={{
          height: "fit-content",
          textAlign: "center",
          width: "80vw",
          padding: "2rem",
          margin: "auto",
        }}
      >
        <Typography
          variant="h1"
          gutterBottom
          fontWeight={600}
          sx={{
            fontSize: { xs: "3rem", md: "5rem", lg: "6rem" },
            fontWeight: { xs: "800", md: "600" },
          }}
        >
          <Typography
            variant="h1"
            fontWeight={600}
            sx={{
              color: "#074DC0",
              fontSize: { xs: "4rem", md: "5rem", lg: "6rem" },
            }}
          >
            EPIC GROWTH
          </Typography>{" "}
          FOR YOUR D2C BRAND
        </Typography>
        <Typography
          variant="h6"
          sx={{ width: { xs: "80vw", md: "75%" }, margin: "auto" }}
          gutterBottom
          fontWeight={400}
        >
          Boost sales, engange with your customers, reduce RTO and uplift
          conversions using APIK’S advanced algorithms!
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="large"
          sx={{
            marginTop: "2rem",
            background: "linear-gradient(to right, #6716CC 0%, #074DC0 97%)",
            padding: "0.8rem 5rem",
            borderRadius: "35px",
          }}
          onClick={handleScroll}
        >
          LET'S TALK
        </Button>
      </Box>
    </Box>
  );
}
